export class Uap {
  constructor(){
    var userAgent = navigator.userAgent;
    this._regexes = require("../../../vendor/uap-core/regexes").regexes;
    this._parser = require("uap-ref-impl/lib/parser")(this._regexes);
    this._result = this._parser.parse(userAgent);
  }

  compact(arr){
    var tempArr = [];
    for(var index in arr){
      var el = arr[index];
      if(el){
        tempArr.push(el);
      }
    }
    return tempArr;
  }

  result(){
    return this._result;
  }

  getBrowser(){
    var ua = this.result().ua;
    var name = ua.family;
    var version = this.compact([ua.major, ua.minor, ua.patch]).join(".");
    return { name: name, version: version, major: ua.major, minor: ua.minor, patch: ua.patch };
  }

  getOS(){
    var os = this.result().os;
    var name = os.family;
    var version = this.compact([os.major, os.minor, os.patch, os.patchMinor]).join(".");
    return { name: name, version: version };
  }

  getDevice(){
    var device = this.result().device;
    var model = device.family;
    var vendor = device.brand;
    return { model: model, vendor: vendor };
  }
}
